import { render, staticRenderFns } from "./Jobbkup.vue?vue&type=template&id=2b4f1f68"
import script from "./Jobbkup.vue?vue&type=script&lang=js"
export * from "./Jobbkup.vue?vue&type=script&lang=js"
import style0 from "./Jobbkup.vue?vue&type=style&index=0&id=2b4f1f68&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports